import { c as _c } from "react/compiler-runtime";
import { useClubsFiltersOpenedStore, useClubsFiltersStore, useClubsFiltersThemeShowStore } from "@/stores/clubs-filters-store";
import { getIconBySlug } from "@/utils/icon-mapping";
interface ClubFilterThemeItemProps {
  label: string;
  icon: string;
  name: string;
}
export default function ClubFilterThemeItem(t0) {
  const $ = _c(18);
  const {
    icon,
    label,
    name
  } = t0;
  const setTheme = useClubsFiltersStore(_temp);
  const setThemeShow = useClubsFiltersThemeShowStore(_temp2);
  const setFiltersClosed = useClubsFiltersOpenedStore(_temp3);
  let t1;
  if ($[0] !== setFiltersClosed || $[1] !== setTheme || $[2] !== setThemeShow) {
    t1 = (label_0, name_0) => {
      setTheme(label_0);
      setThemeShow(name_0);
      setFiltersClosed();
    };
    $[0] = setFiltersClosed;
    $[1] = setTheme;
    $[2] = setThemeShow;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const setThemeValues = t1;
  let t2;
  if ($[4] !== icon) {
    t2 = getIconBySlug(icon);
    $[4] = icon;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const ThemeIcon = t2;
  let t3;
  if ($[6] !== label || $[7] !== name || $[8] !== setThemeValues) {
    t3 = () => setThemeValues(label, name);
    $[6] = label;
    $[7] = name;
    $[8] = setThemeValues;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== ThemeIcon) {
    t4 = <div className="w-[30px] h-[30px] min-w-[30px] min-h-[30px] bg-yellow rounded-[5px] flex items-center justify-center"><ThemeIcon className="w-5 h-5 text-black" /></div>;
    $[10] = ThemeIcon;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== name) {
    t5 = <p className="font-bold">{name}</p>;
    $[12] = name;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t6 = <div className="flex flex-row justify-start items-center gap-1 w-[45%] hover:cursor-pointer hover:bg-light-grey rounded-[5px] p-1" onClick={t3}>{t4}{t5}</div>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
function _temp3(state_1) {
  return state_1.setFiltersClosed;
}
function _temp2(state_0) {
  return state_0.setThemeShow;
}
function _temp(state) {
  return state.setTheme;
}